<template>
  <div>
    <tabs
      mode="emitter"
      class="has-background-light is-border-bottom"
      :links="userReservationsLinks"
      :is-fullwidth="false"
      :current-tab="tab"
      :level="2"
      @changeView="tab = $event"></tabs>
    <table-controls-vue
      v-if="ReservationsList && ReservationsList.length"
      :has-sticky="true"
      :reload-controls="ReservationsList">
      <table class="table is-fullwidth is-marginless has-cells-vcentered">
        <thead>
          <tr class="is-size-6">
            <th class="is-narrow">
              Ref. ADV
            </th>
            <th>Réservation</th>
            <th>Lot</th>
            <th>Programme</th>
            <th>Promoteur</th>
            <th>Aquéreur</th>
            <th class="is-narrow">
              Prix de vente
            </th>
            <th>Acte</th>
            <th class="is-narrow">
              Taux com.
            </th>
            <th>Com.</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="is-size-6">
          <tr
            v-for="reservation in ReservationsList"
            :key="reservation.pk">
            <router-link
              tag="td"
              class="is-cell-hoverable has-cursor-pointer"
              :to="{name: 'AdvInfos', params: {id: reservation.pk}}">
              {{ reservation.ref }}
            </router-link>
            <td>
              <span v-if="reservation.signature_date">{{ reservation.signature_date|shortDate }}</span>
              <span v-else>N.C</span>
            </td>
            <router-link
              tag="td"
              class="is-cell-hoverable has-cursor-pointer"
              :to="{name: 'LotVue', params: {id: reservation.lot_data.pk}}">
              {{ reservation.lot_data.ref }}
            </router-link>
            <router-link
              tag="td"
              class="is-narrow is-cell-hoverable has-cursor-pointer"
              :to="{name: 'ProgramVue', params: {id: reservation.program.pk}}">
              <span :title="reservation.program.name">{{ reservation.program.name | truncate }}</span>
            </router-link>
            <td class="is-narrow">
              <span :title="reservation.promoteur.name">{{ reservation.promoteur.name | truncate }}</span>
            </td>
            <td class="is-narrow">
              {{ reservation.contact.first_name | smallFirstName }} {{ reservation.contact.last_name }}
            </td>
            <td class="is-narrow">
              {{ reservation.sale_price_ttc | prettyPrice }} €
            </td>
            <td><span v-if="reservation.sale_date">{{ reservation.sale_date | shortDate }}</span><span v-else>--</span></td>
            <td><span v-if="reservation.seller_remuneration">{{ reservation.seller_remuneration }} %</span><span v-else>--</span></td>
            <td class="is-narrow">
              <span v-if="reservation.seller_remuneration && reservation.sale_price_ttc">
                {{ reservation.sale_price_ttc / 100 * reservation.seller_remuneration | prettyPrice }} €
              </span>
              <span v-else>--</span>
            </td>
            <td class="has-text-centered actions">
              <display-button-list
                :force-drop-down="false"
                :buttons="ReservationsButtonList"
                :data="reservation"></display-button-list>
            </td>
          </tr>
          <!--<tr class="empty empty--row" v-for="n in ReservationsList.length < 2 ? 2 - ReservationsList.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
        </tbody>
      </table>
    </table-controls-vue>
    <div
      class="is-padding"
      v-else>
      Aucune vente à afficher
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'CompanyReservations',
  props: {
    companyReservations: {
      type: Array
    }
  },
  data () {
    return {
      tab: 'RESERVED',
      ReservationsButtonList: [
        {
          icon: 'fa-eye',
          // text: 'Voir',
          action: (advPk) => {
            this.$router.push({ name: 'AdvInfos', params: { id: advPk } })
          }
        }
      ],
      reloadControlsTable: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isOperator']),
    /**
      * reservations tab
      * @returns {object[]}
      */
    userReservationsLinks () {
      return [
        { link: 'PRE_RESERVED', label: 'Pré-Réservées (' + this.preReservedReservations.length + ')' },
        { link: 'RESERVED', label: 'Réservées (' + this.reservedReservations.length + ')' },
        { link: 'APPROVED', label: 'Actées (' + this.actedReservations.length + ')' },
        { link: 'CANCELED', label: 'Annulées (' + this.canceledReservations.length + ')' }
      ]
    },
    /**
      * return reservation list by tab
      * @returns {object[]}
      */
    ReservationsList () {
      if (this.tab === 'APPROVED') {
        return this.actedReservations
      } else if (this.tab === 'CANCELED') {
        return this.canceledReservations
      } else if (this.tab === 'PRE_RESERVED') {
        return this.preReservedReservations
      } else if (this.tab === 'RESERVED') {
        return this.reservedReservations
      } else {
        return []
      }
    },
    currentView () {
      return this.$route.name
    },
    /**
      * filter reservations by status reserved
      * @returns {object[]}
      */
    reservedReservations () {
      return orderBy(this.companyReservations.filter(x => x.status === 'reserved'), s => moment(s.created_on).format('x'), ['desc'])
    },
    /**
      * filter reservations by status pre_reserved
      * @returns {object[]}
      */
    preReservedReservations () {
      return orderBy(this.companyReservations.filter(x => x.status === 'pre_reserved'), s => moment(s.created_on).format('x'), ['desc'])
    },
    /**
      * filter reservations by status sold
      * @returns {object[]}
      */
    actedReservations () {
      return orderBy(this.companyReservations.filter(x => x.status === 'sold'), s => moment(s.created_on).format('x'), ['desc'])
    },
    /**
      * filter reservations by status canceled
      * @returns {object[]}
      */
    canceledReservations () {
      return orderBy(this.companyReservations.filter(x => ['canceled'].includes(x.status)), s => moment(s.created_on).format('x'), ['desc'])
    }
  }
}
</script>
